module.exports = __webpack_public_path__ + "img/Background-Coasters-no-text-jpg.003b6cd6.webp";